import { render, staticRenderFns } from "./MpDrawV2.vue?vue&type=template&id=50b05d59&scoped=true&"
import script from "./MpDrawV2.vue?vue&type=script&lang=js&"
export * from "./MpDrawV2.vue?vue&type=script&lang=js&"
import style1 from "./MpDrawV2.vue?vue&type=style&index=1&id=50b05d59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b05d59",
  null
  
)

export default component.exports